<template>
 <div id="in">
      <table height="100px"><tr>
      <td style="width: 180px" >
        <div align='right'><el-avatar
         class="md-head-pic"
         shape="square"
         :size="90"
         src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
         @error="errorHandler">
         <img :src="error_url" />
     </el-avatar>
        </div></td>
     <td style="width: 150px">
       <div class="usename" align='left'><span style="font-size:23px;font-weight:500;">×××用户您好</span></div></td>
       </tr>
      </table>
 <el-divider></el-divider>
  </div>
</template>

<script>

 export default {
  name:'',
  props:[''],
  data () {
   return {

   };
  },
 }

</script>
<style lang='scss' scoped>
#in{
  margin-top: 40px;
  height: 130px;
  line-height: 130px;
  background-color: rgb(251,251,251);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.md-head-pic{
  vertical-align: middle;
}
</style>